import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_bgc--white gfu-announcement-box__slider gfu-announcement-box" }
const _hoisted_2 = { class: "gfu-base-carousel-slide is-active" }
const _hoisted_3 = { class: "gfu-background-swept gfu-announcement-content _gap-5" }
const _hoisted_4 = { class: "gfu-1of1 gfu-1of2--m" }
const _hoisted_5 = { class: "_flexcol _gap-1 _grow-1" }
const _hoisted_6 = { class: "_flex _jc-sb" }
const _hoisted_7 = { class: "_flex _jc-c _mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_button = _resolveComponent("skeleton-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_skeleton_image, { class: "gfu-announcement-content__packshot-wrapper" }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_skeleton_line, { height: 18 }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_skeleton_line, {
                height: 10,
                class: "_flex-basis-60"
              }),
              _createVNode(_component_skeleton_line, {
                height: 10,
                class: "_flex-basis-33"
              })
            ]),
            _createVNode(_component_skeleton_line, { height: 10 }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_skeleton_button, { class: "_flex-basis-50" })
            ])
          ])
        ])
      ])
    ])
  ]))
}